// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__38DEc","item":"PaymentsMobile_item__10OtN","label":"PaymentsMobile_label__1waMw","amount":"PaymentsMobile_amount__374pJ"};